import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ITextSearchBehavior } from "../../../../documaker/domain/format/objects";

export interface ITextSearchBehaviorPropertyEditable {
  textSearchBehavior(): IPropertyEditable<ITextSearchBehavior>;
}

export function instanceOfITextSearchBehaviorPropertyEditable(instance: any): instance is ITextSearchBehaviorPropertyEditable {
  return instance
      && instance.textSearchBehavior
      && instanceOfIPropertyEditable<ITextSearchBehavior>(instance.textSearchBehavior());
}
